const deleteEquipmentServices = {
  toastr: 'Deleted Service'
};

export default deleteEquipmentServices;
